export enum CashRegisterStoryType {
  IN = 'wpłata',
  OUT = 'wypłata',
}
